import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed8f28d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-edit-bank" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = { class: "line1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line2" }, "Banks", -1))
const _hoisted_5 = { class: "body-main" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "input-box ma-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-name" }, "Name of bank *", -1))
const _hoisted_9 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-name" }, "Status", -1))
const _hoisted_12 = { class: "row" }
const _hoisted_13 = {
  class: "mr-2",
  style: {"width":"150px"}
}
const _hoisted_14 = { class: "radio" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Active")
], -1))
const _hoisted_16 = { style: {"float":"left"} }
const _hoisted_17 = { class: "radio" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Inactive")
], -1))
const _hoisted_19 = { class: "controls" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-right" })
], -1))

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[5] || (_cache[5] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(!_ctx.editMode ? 'Add new bank' : 'Edit ' + _ctx.formData.name), 1),
          _hoisted_4
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.formData.name) = $event)),
                maxlength: "200"
              }, null, 512), [
                [_vModelText, _ctx.formData.name]
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["footnote", [ _ctx.formData.name.length === 200 ? 'full' : '']])
              }, _toDisplayString(_ctx.formData.name.length) + "/200 characters ", 3),
              (_ctx.formData.name === '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _createTextVNode(" Mandatory field ")
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "status",
                  id: "status",
                  value: 1,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.status) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.status]
                ]),
                _hoisted_15
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "status",
                  id: "status",
                  value: 2,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.status) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.status]
                ]),
                _hoisted_18
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", {
            class: "btn btn-default ml-1",
            disabled: _ctx.submitting,
            onClick: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
          }, "Back", 8, _hoisted_20),
          _createElementVNode("button", {
            class: "btn btn-primary",
            disabled: _ctx.submitting || !_ctx.isFormDirty,
            onClick: _cache[4] || (_cache[4] = _withModifiers($event => (_ctx.saveBank()), ["prevent","stop"]))
          }, [
            _createTextVNode(_toDisplayString(!_ctx.editMode ? 'Add' : 'Save changes'), 1),
            _hoisted_22
          ], 8, _hoisted_21),
          (_ctx.submitting)
            ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                key: 0,
                class: "loading-indicator",
                showLoadingText: false
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}